import React from 'react';
import { Layout, SEO } from 'components/common';
import { Impressum } from 'components/landing/Impressum';

export default () => (
  <Layout>
    <SEO />
    <Impressum/>
  </Layout>
);
